import { ArrowPathIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedDocumentStatusChangedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityActions,
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityLink,
  ActivityStatusTransition,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatStatus } from '../activity-feed-v2/utils';

export interface DocumentStatusChangedEventProps {
  event: DiscriminatedDocumentStatusChangedEvent;
}

export const DocumentStatusChangedEvent: React.FC<
  DocumentStatusChangedEventProps
> = ({ event }) => {
  const { document, old_status, new_status } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100">
          <ArrowPathIcon className="h-4 w-4 text-blue-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <div className="flex items-center gap-3">
        {document?.document_template?.name && (
          <ActivityTitle>{document.document_template.name}</ActivityTitle>
        )}
        {old_status && new_status && (
          <ActivityStatusTransition
            from={formatStatus(old_status)}
            to={formatStatus(new_status)}
          />
        )}
      </div>
    </ActivityBody>
  );

  const actions = document?.id && (
    <ActivityActions>
      <ActivityLink href={`/${event.matter_id}#letters`}>
        View Agreements
      </ActivityLink>
    </ActivityActions>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Agreement Status Changed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
      actions={actions}
    />
  );
};
